export default __webpack_public_path__ + "static/media/020-laptop.3154ce41.svg";